import { Grid, Tooltip,IconButton, Chip,Typography } from "@material-ui/core";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import {makeStyles } from '@material-ui/core/styles';
import {useDispatch} from 'react-redux';
import { useHistory,useLocation } from "react-router-dom";
import * as userActions from '../../../actions/authenticationActions';
import {HEADER_TEXTS} from '../../../utility';

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
      color: theme.palette.common.white,
    },
    tooltip: {
      backgroundColor: theme.palette.primary.main,
    },
  }));

const useStyles = makeStyles((theme) => ({
    root: {
      transform: 'translateZ(0px)',
      flexGrow: 1,
    },
    exampleWrapper: {
      position: 'relative',
      marginTop: theme.spacing(3),
      height: 380,
    },
    radioGroup: {
      margin: theme.spacing(1, 0),
    },
    speedDial: {
      position: 'absolute',
      '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
        bottom: theme.spacing(2),
        right: theme.spacing(2),
      },
      '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
        top: theme.spacing(2),
        left: theme.spacing(2),
      },
    },
}));


function DashboardHeader(props){
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const actions = [
        { icon: <AccountCircleIcon />, name: (props.Briefs.users) ? props.Briefs.users[0][1] : null },
        { icon: <ExitToAppIcon />, name: 'Logout' },
      ];
    const Logout = ()=>{
        dispatch(userActions.logoutUser());
    }

    const DashboardView = () => {
        history.push('/');
    }
    return(
        <Grid container xs="12" md="12" direction="row" alignItems="center" style={{padding:'0',textAlign:'center',background:'rgb(249, 249, 249)'}}>
          {(props.goBack)?
            <Grid item direction="row" xs='3'>
                <Tooltip title={HEADER_TEXTS.BACK_BUTTON_LABEL} arrow classes={useStylesBootstrap()} style={{marginLeft:'0.5rem', padding: '10px'}}>
                    <IconButton  aria-label="Back" onClick={DashboardView}>
                        <KeyboardBackspaceIcon color="primary" style={{color: '#859fbd'}} />
                    </IconButton>
                </Tooltip>
            </Grid>: null}
            <Grid item direction="row" xs={(props.goBack)? "6" : "9"} style={{padding:'0.7rem 0rem'}}>
              {(!props.TopicName && !props.goBack) ? 
                <Typography variant="subtitle2" color="primary" style={{textAlign: 'left', marginLeft: '20px', color: '#859fbd'}}>
                  {(props.Briefs.users) ? `${HEADER_TEXTS.LOGGED_IN_TEXT} ${props.Briefs.users[0][1]}` : HEADER_TEXTS.NOT_LOGGED_IN_TEXT}
                </Typography>
                : 
                <Typography variant="subtitle2" color="primary" style={{fontSize: '12px', fontWeight: 'bold', color: '#9ca2aa'}}>
                  {props.TopicName}
                </Typography>}
            </Grid>
            <Grid item direction="row" xs='3'>
              {(props.isNotLoggedIn)? null : 
                <Tooltip title={HEADER_TEXTS.LOGOUT_ICON_LABEL} arrow classes={useStylesBootstrap()} style={{marginRight:'0.5rem', padding: '10px'}}>
                    <IconButton aria-label="Logout" onClick={Logout}>
                        <ExitToAppIcon color="primary" style={{color: '#859fbd'}} />
                    </IconButton>
                </Tooltip>
                }
            </Grid>
        </Grid>
    );

}

export default DashboardHeader;